(function () {

  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').config(Config);

  function Config($stateProvider) {
    $stateProvider
      .state('visualizacao.feitosVistaAberta', {
          url: "/feitosVistaAberta",
          templateUrl: "module/validacao/visualizacao/feitosVistaAberta/feitos-vista-aberta.tab.html",
          controller: 'AbaFeitosVistaAberta',
          controllerAs: 'vm'
      })
    ;
  }

})();
